import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_djcfr54fi3: FaireBrandEntity = {
  token: "b_djcfr54fi3",
  type: "brand",
  name: "MOMO dressing",
  avatarUrl:
    "https://cdn.faire.com/fastly/98c5484a69f1e7124519f98245b4650062c7f19052af839299c670f396cfcb5b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b69f5a23226067499246bd688f4b6209846fd130f6b6118e8d32adab3a5ec7f9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/98c5484a69f1e7124519f98245b4650062c7f19052af839299c670f396cfcb5b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b69f5a23226067499246bd688f4b6209846fd130f6b6118e8d32adab3a5ec7f9.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "We at MOMO dressing produce Japanese style salad dressing, sauce and dip with fresh local ingredients in Sunset park, Brooklyn NY since 2013.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:50.585Z",
    importedBy: "entity-db-cli",
  },
};
